import React, { useEffect, useState } from "react";
import { ArrayTotalizarByProp } from "../../../Actions/TotalizarProps";
import { GetMonthNameByNumber } from "../../../Helper/GetMonthNameByNumber";
import { FormatMoney } from "../../../../../Helpers/FormatNumber";
import { AgruparConsolidado, NivelInventarioDias, NivelInventarioDiasAnt } from "../Agrupar";

export const Consolidado = ({ data, ejercicio, mes }) => {
  const [state, setState] = useState([]);
  const [totales, setTotales] = useState({
    invactual: 0,
    invanterior: 0,
  });
  useEffect(() => {
    setState(AgruparConsolidado(data));
    setTotales({
      invactual: ArrayTotalizarByProp(data, "invactual"),
      invanterior: ArrayTotalizarByProp(data, "invanterior"),
      dias: ArrayTotalizarByProp(data, "dias"),
      diasant: ArrayTotalizarByProp(data, "diasant"),
    });
  }, [data]);
  return (
    <div id="container-inventario-detallado">
      <table id="inventario-detallado-consolidado-reporte" cellSpacing={0}>
        <thead>
          <tr>
            <th rowSpan={2}>Linea</th>
            <th colSpan={4}>Periodo</th>
            <th>Diferencia </th>
          </tr>
          <tr>
            <th>
              {GetMonthNameByNumber(mes)} - {ejercicio}
            </th>
            <th>Días</th>
            <th>
              {GetMonthNameByNumber(mes)} - {ejercicio - 1}
            </th>
            <th>Días</th>
            <th>
              {ejercicio} vs {ejercicio - 1}
            </th>
          </tr>
        </thead>
        <tbody>
          {state.map((item) => (
            <tr>
              <td>{item.concepto}</td>
              <td>{FormatMoney(item.invactual, 0)}</td>
              {/* <td>{item.dias}</td> */}
              <td>{FormatMoney(NivelInventarioDias(data,item.concepto),0)}</td>
              <td>{FormatMoney(item.invanterior, 0)}</td>
              <td>{FormatMoney(NivelInventarioDiasAnt(data,item.concepto),0)}</td>
              <td>
                {FormatMoney((item.invactual / item.invanterior - 1) * 100, 0)}{" "}
                %
              </td>
            </tr>
          ))}
          <tr className="totales">
            <td>TOTALES</td>
            <td>{FormatMoney(totales.invactual, 0)}</td>
            <td></td>
            {/* <td>{totales.dias}</td> */}
            <td>{FormatMoney(totales.invanterior, 0)}</td>
            <td></td>
            {/* <td>{totales.diasant}</td> */}
            <td>
              {FormatMoney(
                (totales.invactual / totales.invanterior - 1) * 100,
                0
              )}{" "}
              %
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
